"use no memo";

// This module is for convenient versions of functions which can be partially applied (ie one arg at a time)

export const is = (x) => (y) => x === y;

export const includes = (arr) => (val) => arr.includes(val);
